export const checkFields = [
  {
    label: 'Defensa pública (gratuita)',
    value: 'defensa_publica',
  },
  {
    label: 'Defensa privada',
    value: 'defensa_privada',
  },
  {
    label: 'Defensa pública y privada',
    value: 'defensa_publica_privada',
  },
  {
    label: 'Representación social',
    value: 'representacion',
  },
  {
    label: 'No contaron con representación legal',
    value: 'no_representacion',
  },
  {
    label: 'No identificado',
    value: 'no_identificado',
  },
];
